<template>
  <div
    class="card-main"
    @click="clickCard"
    @mouseover="focusOn"
    @mouseout="focusOut"
  >
    <div class="focus-ring" v-show="isfocusOn && mouseActivated"></div>
    <img
      class="cover-img"
      :class="{ foused: isFocued }"
      v-lazy="cardData.imgUrl"
    />
    <!-- <img class="cover-img" :src="cardData.imgUrl" /> -->
    <span class="card-text" :class="{ foused: isFocued }">
      <div class="title doubleline">{{ cardData.title }}</div>
      <div class="vtype">{{ cardData.vtype }}</div>
    </span>
  </div>
</template>

<script>
import { contentsPermissionCheck } from "@/utils/common"

export default {
  data() {
    return {
      isActiveVue: true,
      isfocusOn: false,
    };
  },
  props: ["cardData", "focuseId"],

  computed: {
    isFocued() {
      return this.mouseActivated
        ? this.isfocusOn
        : this.focuseId == this.cardData.id;
    },
    mouseActivated() {
      return this.$store.getters.mouseActivated;
    },
  },

  methods: {
    async clickCard() {
      const checkParams = {
        type: this.cardData.type,
        id: this.cardData.id
      }

      // 리그 전용 이용권 시청 권한 확인
      const checkValue = await contentsPermissionCheck(checkParams)

      if (checkValue) {
        this.focusOut();
        this.$router.push({
          name: "player",
          params: {
            vodId: this.cardData.id,
            contentType: this.cardData.type,
          },
        });
      }
    },
    focusOn() {
      this.isfocusOn = true;
    },
    focusOut() {
      this.isfocusOn = false;
    },
  },
};
</script>

<style scoped>
.card-main {
  position: relative;
  margin-right: 20px;
  padding-bottom: 24px;
}
.cover-img {
  width: 394px;
  height: 222px;
  opacity: 0.3;
}
.dim {
  position: absolute;
  top: 0px;
  width: 394px;
  height: 222px;
  opacity: 0.3;
  background: black;
  z-index: 2;
}
.card-text {
  vertical-align: top;
  padding: 8px;
  display: inline-block;
  opacity: 0.3;
}

.title {
  width: 760px;
  font-size: 32px;
  line-height: 1.5;
  color: #a0a0a0;
}
.vtype {
  position: absolute;
  top: 122px;
  width: 760px;
  font-size: 24px;
  line-height: 1.33;
  color: #707070;
}
.focus-ring {
  position: absolute;
  top: -4px;
  height: 222px;
  width: 1174px;
  border: solid 4px #eeeeee;
  z-index: 5;
}
.foused {
  opacity: 1;
  transition-duration: 0.3s;
}

@media all and (min-width:0px) and (max-width:1280px){
  .card-main {
    position: relative;
    margin-right: 20px;
    padding-bottom: 24px;
  }

  .card-text {
    vertical-align: top;
    padding: 16px;
    display: inline-block;
    opacity: 0.3;
  }

  .title {
    width: 654px;
    font-size: 20px;
    line-height: 1.5;
    color: #ffffff;
  }
  .vtype {
    position: absolute;
    top: 101px;
    width: 654px;
    font-size: 16px;
    line-height: 1;
    color: #888888;
  }

  .cover-img {
    width: 266px;
    height: 150px;
    opacity: 0.3;
  }
  .focus-ring {
    position: absolute;
    top: -3px;
    height: 156px;
    width: 942px;
    border: solid 3px #eeeeee;
    z-index: 5;
  }
  .foused {
    opacity: 1;
    transition-duration: 0.3s;
  }
}
</style>